export default __webpack_public_path__ + "static/media/comingSoon.89976d0f.png";